import * as React from "react";
import { Box, Button, Typography, Modal } from "@mui/material";
import SuccessIcon from "../../assets/images/SuccessIcon.svg";
import "./style.css";
import useTranslation from "../../hooks/translations";
import { AccessTime } from "@mui/icons-material";

interface PaymentSuccessModalProps {
  amount: number;
  transactionId: string;
  isOpen: boolean;
  onClose: any;
  returnUrl: string;
}
const COUNT_DOWN_TIME = 9;

const PaymentSuccessModal: React.FC<PaymentSuccessModalProps> = ({
  amount,
  transactionId,
  isOpen,
  onClose,
  returnUrl,
}) => {
  const [countDownToRedirect, setCountDownToRedirect] =
    React.useState(COUNT_DOWN_TIME);

  const { t } = useTranslation();

  const returnToMerchantPage = (url: string) => {
    window.location.replace(url);
  };

  React.useEffect(() => {
    const interval = setInterval(() => {
      setCountDownToRedirect((prev: number) => prev - 1);
    }, 1000);
    if (countDownToRedirect <= 0) {
      clearInterval(interval);
      window.location.replace(returnUrl);
    }
    return () => clearInterval(interval);
  }, [countDownToRedirect, setCountDownToRedirect, returnUrl]);

  return (
    <Modal
      open={isOpen}
      onClose={(e, reason) => onClose(e, reason)}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box className={"box"}>
        <Box className={"imageBox"}>
          <img src={SuccessIcon} alt="success" />
        </Box>
        <Typography
          variant="h4"
          component="h2"
          gutterBottom
          className={"centerText"}
        >
          {t("paymentSuccessful")}
        </Typography>
        <Typography
          variant="body1"
          component="p"
          gutterBottom
          sx={{ color: "#667085", marginBottom: 1.5 }}
          className={"centerText"}
        >
          {t("paymentCompletedSuccessfully")}
        </Typography>
        <Typography
          variant="body1"
          component="p"
          gutterBottom
          sx={{ color: "#667085", marginBottom: 1.5 }}
          className={"centerText"}
        >
          {t("redirectToMerchant")}
        </Typography>
        <Box
          sx={{
            alignItems: "center",
            textAlign: "center",
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
          }}
          gap={0.5}
        >
          <AccessTime fontSize="small" color="primary" />
          <Typography sx={{ color: "#0AA5B7" }}>
            {" "}
            {`0:0${countDownToRedirect}`}
          </Typography>
        </Box>
        <Button
          variant="contained"
          onClick={() => returnToMerchantPage(returnUrl)}
          sx={{ color: "white", mt: 2, textTransform: "capitalize" }}
          className={"button"}
        >
          {t("return")}
        </Button>
      </Box>
    </Modal>
  );
};

export default PaymentSuccessModal;
